<template>
    <div class="result-paging-wrapper">

        <div v-if="length>=1" class="row">

            <div class="col-sm-6">
                <div class="text-holder">
                    Mostrando 1-{{length}} de {{length}}
                </div>
            </div>

            <div class="col-sm-6">
                <ul class="paging">
                    <li class="disable"><a href="#">&laquo;</a></li>
                    <li class="active"><a href="#">1</a></li>
                    <li><a href="#">&raquo;</a></li>
                </ul>
            </div>

        </div>

    </div>
</template>
<script>
    export default {
        name: 'pagination',
        props: ['length']
    }
</script>
<style scoped>
    ul.paging li.active a, ul.paging li a:hover {
        background: #8ac6c4 !important;
    }
</style>